import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";

import $ from "jquery";
import {
  getAxiosResponse,
  putAxiosResponse,
} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { useSelector, useDispatch } from "react-redux";
import { timeStamp, addDaysToDate, getDateDifference as getDateDifference } from "../../../services/Util";
import Constants from "../../../Constants";
import { currentDateWithFormat } from "../../../services/Util";
import { transformBlankToNull } from "../../../services/Util";
import CustomProgressBar from "../../global/CustomProgressBar";
import axios from "axios";
import DatePickerCalendar from "../../dashboard/calendars/DatePickerCalendar";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import dateUtil from "../../../services/DateUtil";
import store from "../../../redux/store";

export default function EditCustomTaskForm(prop) {
  const projectId = prop.id;

  const inputRef = useRef(null);
  const [toggle, toggleCal] = useState(false);
  const [toggle1, toggleCal1] = useState(false);
  const [taskName, setTaskName] = useState("");
  const [taskDescription, setTaskDescription] = useState("");
  const [selectedAssignedUser, setSelectedAssignedUser] = useState("");
  const [selectedNotifyUser, setSelectedNotifyUser] = useState([]);
  const [showNotificationUsers, setShowNotificationUsers] = useState([]);
  const refToggle = useRef(null);
  const refToggle1 = useRef(null);
  const refCalendar = useRef(null);
  const refCalendar1 = useRef(null);
  const [users, setUsers] = useState([]);
  const [rawTaskData, setRawTaskData] = useState("");
  const [validation, setValidation] = useState(true);
  const [notifyUsers, setNotifyUsers] = useState([]);
  // const [languageFilter, setLanguageFilter] = useState([]);
  const [selectedLanguages, setLanguage] = useState("");
  const [selectedfile, setSelectedFile] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [allUsers, setAllUsers] = useState([]);
  const [followers, setFollowers] = useState([]);
  const [reminderDay, setReminderDay] = useState("");
  const [allowReminder, setAllowReminder] = useState(false);
  const [reminderDateStatus,setReminderStatus]=useState(false);
  const [selectedTaskStatus, setTaskStatus] = useState("");
  const [selectedTaskStatusPayload, setTaskStatusPayload] = useState("");
  const customerTimeZone = store.getState()?.customer_bootstrap_data?.value?.user?.timeZone;
  const projectData = useSelector((reduxStore) => reduxStore.project_info).value;


  const taskStatus = [
    { label: "--Select One--", value: "",data:"" },
    { label: "Open", value: "OPEN",data:{display: "Open", code: "open", originalEnum: "OPEN"} },
    { label: "Completed", value: "CLOSED",data:{display: "Closed", code: "closed", originalEnum: "CLOSED"} },
    { label: "Rejected", value: "REJECTED",data:{display: "Rejected", code: "rejected", originalEnum: "REJECTED"} },
    { label: "Cancelled", value: "CANCELLED",data:{display: "Cancelled", code: "cancelled", originalEnum: "CANCELLED"} },
  ];
  const checkValidation = (event) => {
    if (taskName === "" || selectedAssignedUser === "") {
      setValidation(false);
    } else {
      setValidation(true);
    }
  };

  

  const showCalendarStartDate = (event) => {
    toggle ? toggleCal(false) : toggleCal(true);
    $('#calFirstFocus').toggleClass('calFirstFocus')
    $('.calFirstFocus').trigger('focus')
    $(document).mouseup(function(e) {
      var bannerCont = $('.firstCal');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        toggleCal(false)
        $('#calFirstFocus').removeClass('calFirstFocus')
     }
    });
    if (toggle) {
      var requiredElement = document.querySelector(".dashCalendar");
      requiredElement.focus();
    }
  };
  $("#calFirstFocus").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      if($('div').hasClass('dashCalendar')){
        toggleCal(false)
        $('.calFirstFocus').trigger('focus')
        $('#calFirstFocus').removeClass('calFirstFocus')
       }
     }
     if (e.key === Constants.TAB && e.shiftKey) {
      if($('div').hasClass('dashCalendar')){
        toggleCal(false)
        $('.calFirstFocus').trigger('focus')
        $('#calFirstFocus').removeClass('calFirstFocus')
       }
     }
    });
    const handleEscFocus = (event) => {
      if (event.key === Constants.ESCAPE) {
        toggleCal(false)
          $('.calFirstFocus').trigger('focus')
          $('#calFirstFocus').removeClass('calFirstFocus')
      }
    }
  const showCalendarDueDate = (event) => {
    toggle1 ? toggleCal1(false) : toggleCal1(true);
    $('#calSecondFocus').toggleClass('calSecondFocus')
    $('.calSecondFocus').trigger('focus')
    $(document).mouseup(function(e) {
      var bannerCont = $('.caltopset');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        toggleCal1(false)
        $('#calSecondFocus').removeClass('calSecondFocus')
     }
     });
    if (toggle1) {
      var requiredElement = document.querySelector(".dashCalendar1");
      requiredElement.focus();
    }
  };
  
  $("#calSecondFocus").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      if($('div').hasClass('dashCalendar1')){
        toggleCal1(false)
        $('.calSecondFocus').trigger('focus')
        $('#calSecondFocus').removeClass('calSecondFocus')
       }
     }
     if (e.key === Constants.TAB && e.shiftKey) {
      if($('div').hasClass('dashCalendar1')){
        toggleCal1(false)
        $('.calSecondFocus').trigger('focus')
        $('#calSecondFocus').removeClass('calSecondFocus')
       }
     }
   });
   const handleEscFocus2 = (event) => {
    if (event.key === Constants.ESCAPE && event.target.ariaExpanded === 'true') {
        toggleCal1(false)
        $('.calSecondFocus').trigger('focus')
        $('#calSecondFocus').removeClass('calSecondFocus')
    }
  }
  const removeItem = (id) => {
    setShowNotificationUsers((current) =>
      current.filter(
        (showNotificationUsers) => showNotificationUsers.value !== id
      )
    );

    setSelectedNotifyUser((current) =>
      current.filter(
        (selectedNotifyUser) => selectedNotifyUser.value !== id
      )
    );
    
    const selectedElement = $(document.activeElement).closest(".multiselect-output");
    if($(document.activeElement).is(':last-child') &&
      selectedElement.children().length > 1){
        selectedElement.find('button:nth-last-child(2)').trigger('focus');
    } else if($(document.activeElement).is(':last-child')){
      $(document.activeElement).closest(".wrap-dropdown").find('.global-dropdown-block input:first-of-type').trigger('focus');
    }
  };
  const setReminder = (e) => {
    setAllowReminder(e.target.checked);
    if(rawTaskData?.emailReminderDay){
      setReminderDay(rawTaskData?.emailReminderDay)
    }
    if (e.target.checked === false) {
      $("#task-email-reminder-day").val("");
    }
  };
  const handleReminderDay = (event) => {
    setReminderStatus(false)
    var element = $("#emailReminderDay");
    element.val(element.val().replace(/[^0-9\.]/g, ""));
    setReminderDay(event.target.value);
    if(getDateDifference(startDate,dueDate) < event?.target?.value){
      setReminderStatus(true)
    }
  };
  const handleAssignedUserChange = (event) => {
    setSelectedAssignedUser(event.isVendor ? "-"+event.value : event.value);
  };
  const handleNotifyUserChange = (event) => {
    var selectedId = event.value;
    if (event.value === "all-follower") {
      setShowNotificationUsers(followers);
    } else if (event.value === "other-dept-users") {
      setShowNotificationUsers(allUsers);
    } else {
      var result;
      result = allUsers.find(({ value }) => value == selectedId);
      setShowNotificationUsers((current) => [...current, result]);
    }
    setSelectedNotifyUser((current) => [...current, event]);
  };
  const handleTaskStatusChange = (event) => {
    var selectedTaskStatus = event.value;
    setTaskStatus(selectedTaskStatus);
    setTaskStatusPayload(event?.data)
  };
  const handleLanguageChange = (event) => {
    var selectedLang = event.value;
    setLanguage(selectedLang);
  };


  const selectStartDate = (event) => {
    setDueDate("");
    setStartDate(event);
    setRawTaskData({ ...rawTaskData, 'startDate': timeStamp(event, customerTimeZone) })

    refToggle.current.focus();
      toggleCal(false);
      $('.calFirstFocus').trigger('focus')
      $('#calFirstFocus').removeClass('calFirstFocus')
   
  };
  const selectDueDate = (event) => {
    setDueDate(event);
    setRawTaskData({ ...rawTaskData, 'dueDate': timeStamp(event, customerTimeZone) })
      refToggle1.current.focus();
      toggleCal1(false);
      $('.calSecondFocus').trigger('focus')
      $('#calSecondFocus').removeClass('calSecondFocus')
    
  };
  const closeCalendar = (e) => {
    if (e.code === "Escape") {
      toggleCal(false);
      $('.calFirstFocus').trigger('focus')
      $('#calFirstFocus').removeClass('calFirstFocus')
    }
  };
  const closeCalendar2 = (e) => {
    if (e.code === "Escape") {
      toggleCal1(false);
      $('.calSecondFocus').trigger('focus')
       $('#calSecondFocus').removeClass('calSecondFocus')
    }
  };

  const updateTask = () => {
    checkValidation();
    var CopyTaskData = structuredClone(rawTaskData);
    var followers = [];
    selectedNotifyUser.map((user) => {
      if(user.isVendor){
        followers.push({
          vendor: {
            id: user.value,
          },
        });
        return;
      }else{
        followers.push({
          customerUser: {
            userId: user.value,
          },
        });
      }
    });
    if (taskName !== "" && selectedAssignedUser !== "") {
      CopyTaskData = transformBlankToNull(CopyTaskData);
      CopyTaskData.assigneeCustomerUser = selectedAssignedUser;
      CopyTaskData.assigneeUser = null;
      CopyTaskData.displayName = taskName;
      CopyTaskData.currentAssignee = selectedAssignedUser;
      CopyTaskData.description = taskDescription;
      CopyTaskData.followers = followers;
      CopyTaskData.emailReminderDay = reminderDay;
      CopyTaskData.status=selectedTaskStatusPayload;
      CopyTaskData.targetLanguage=selectedLanguages;
      var payload = transformBlankToNull(CopyTaskData)
        putAxiosResponse(APIUrls.UPDATE_TASK(prop.taskDetail.id)+"?syncToWorkflow=true", payload)
          .then((res) => {
            if (res.status === 200) {
                prop.funct(prop.taskDetail.id)
            }
          })
          .catch((err) => {
            handleError(err);
          });
    }
  };
  const resetfelds = () => {
    prop.funct(false);
  };
  useEffect(() => {
    // inputRef.current.focus();
    getAxiosResponse(APIUrls.PROJECT_FOLLOWER_USER(projectId))
      .then((res) => {
        if (res.data.code === 200) {
          var users = res.data.data.map(({ resource, displayName }) => ({
            value: resource.userId,
            label:
              resource.firstName +
              " " +
              resource.lastName +
              " (" +
              displayName[0][0] +
              ")",
          }));

          setFollowers(users);
        }
      })
      .catch((err) => {
        handleError(err);
      });
    getAxiosResponse(APIUrls.PROJECT_VISIBILITY_USER(projectId))
      .then((res) => {
        if (res.data.code === 200) {
          var users = res.data.data.map(({ resource, displayName }) => ({
            value: resource.userId,
            label: resource.firstName + " " + resource.lastName + " (" + displayName[0].displayName + ")",
            isVendor: false
          }));
          if(projectData.vendor && projectData.vendor.machineTranslationVendor === false && projectData.vendor.isInternal === false){
            users.push({
              value: projectData.vendor.id,
              label: `${projectData.vendor.name} (Vendor)`,
              isVendor: true
            });
          }
          setAllUsers(users);

          var followers = [
            {
              key: "0",
              value: "all-follower",
              label: "--Select All Project Followers--",
            },
            {
              key: "1",
              value: "other-dept-users",
              label: "--Other Users In Department--",
            },
            ...users,
          ];

          if (showNotificationUsers.length > 0) {
            var filteredFollowers = followers.filter(
                (y) => !showNotificationUsers.some((x) => x.value === y.value)
              )
              //filteredFollowers.sort((a, b) => a.label.localeCompare(b.label));
            setNotifyUsers(filteredFollowers);
          }
        }
      })
      .catch((err) => {
        handleError(err);
      });
  }, [showNotificationUsers]);

  useEffect(() => {
    getAxiosResponse(APIUrls.GET_RAW_TASK_BY_ID(prop.taskDetail.id)).then(
      (res) => {
        setRawTaskData(res.data.data);
        let status=res.data.data.status.originalEnum;
        setStartDate(res?.data?.data?.startDate?.utcTimestamp)
        setDueDate(res?.data?.data?.dueDate?.utcTimestamp)
        setTaskName(res.data.data.displayName);
        setTaskStatus(status);
        setTaskStatusPayload(taskStatus?.filter(data=>data?.value===status)[0]?.data)
        if(res.data.data.assigneeUser.userId === -1){
          setSelectedAssignedUser("-"+res.data.data.assigneeVendor.id)
        }else{
          setSelectedAssignedUser(res.data.data.assigneeUser.userId)
        }
        setLanguage(res?.data?.data?.targetLanguage)
        setTaskDescription(res?.data?.data?.description)
      }
    );
    var selectedFolowers = [];
    var selectedNotifyUsers=[];
    getAxiosResponse(APIUrls.GET_TASK_FOLLOWERS(prop.taskDetail.id)).then(
      (res) => {
        res.data.data.map((data) => {
          if(data.customerUser?.userId){
            const custUser = {
              label:
                data.customerUser.firstName +
                " " +
                data.customerUser.lastName +
                " (" +
                data.customerUser.roleSet.displayName +
                ")",
              value: data.customerUser.userId,
            }
            selectedFolowers.push(custUser);
            selectedNotifyUsers.push(custUser);
          }else{
            const vendor = {
              label: data.vendor.name +" (Vendor)",
              value: data.vendor.id,
              isVendor: true
            }
            selectedFolowers.push(vendor);
            selectedNotifyUsers.push(vendor);
          }
        });
        setShowNotificationUsers(selectedFolowers);
        setSelectedNotifyUser(selectedNotifyUsers);
      }
    );  
  }, [prop]);
 
  return (
    <div className="task-form-content">
      <div className="form-group">
        <h6 className="subhead-taskform">Custom : {rawTaskData.displayName}</h6>
        <div className="flex wrap-dropdown">
          <div className="global-dropdown-block flex-center">
            <label>Task status</label>
            <div className="global-dropdown-select">
              <Select
                classNamePrefix="cw"
                className="global-dropdown-select"
                value={taskStatus.filter(function (option) {
                  return option.value === selectedTaskStatus;
                })}
                aria-label="Task Status"
                options={taskStatus}
                onChange={(e) => handleTaskStatusChange(e)}
              />
            </div>

            {!validation && selectedAssignedUser === "" ? (
              <div className="error" aria-label="error alert" role="alert">
                Please select a user
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <div className="form-group">
        <div className="form-text">
          <label htmlFor="edittask_name">Task name:</label>
          <br />
          <input
            type="text"
            id="edittask_name"
            name="taskName"
            className="form-control-sm"
            defaultValue={rawTaskData.displayName}
            aria-describedby="EdittaskNameFocus"
            ref={inputRef}
            onChange={(event) => setTaskName(event.target.value)}
          />
          {!validation && taskName === "" ? (
            <div className="error" id="EdittaskNameFocus">
              Task name required
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="form-group">
        <div className="form-text">
          <label className="optional-right" htmlFor="DescMassage">
            Description <span>(Optional)</span>
          </label>
          <textarea
            className="textarea form-control-sm"
            placeholder="1000 characters limit"
            id="DescMassage"
            maxLength={1000}
            defaultValue={rawTaskData.description}
            onChange={(event) => setTaskDescription(event.target.value)}
          ></textarea>
        </div>
      </div>
      <div className="form-group">
        <h6 className="subhead-taskform">Select User</h6>
        <div className="flex wrap-dropdown">
          <div className="global-dropdown-block flex-center">
            <label>Assigned To</label>
            <div className="global-dropdown-select">
              <Select
                classNamePrefix="cw"
                className="global-dropdown-select"
                value={allUsers.filter(function (option) {
                  return option.value === selectedAssignedUser || "-"+option.value === selectedAssignedUser;
                })}
                aria-label="Assigned To"
                options={allUsers}
                onChange={(e) => handleAssignedUserChange(e)}
              />
            </div>
            {!validation && selectedAssignedUser === "" ? (
              <div id="user-error" className="error">
                Please select a user
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="global-dropdown-block flex-center">
            <label>Who will receive notifications about this task?</label>
            <div className="global-dropdown-select">
              <Select
                classNamePrefix="cw"
                value={notifyUsers.filter(function (option) {
                  return option.value === selectedNotifyUser;
                })}
                className="global-dropdown-select"
                aria-label="Who will receive notifications about this task"
                options={notifyUsers}
                onChange={(e) => handleNotifyUserChange(e)}
              />
            </div>
            <div className="multiselect-output flex">
              {showNotificationUsers.map((user, index) => {
                return (
                  <button key={index} onClick={() => removeItem(user.value)}
                  aria-label={'remove ' + user.label}
                  >
                    <strong>
                      {
                        user.label
                      }
                    </strong>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="9"
                      viewBox="0 0 10 9"
                      fill="none"
                    >
                      <path
                        d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                        stroke="#213248"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="form-group">
        <h6 className="subhead-taskform border-bottom">
          Language and Attachements <span>(Optional)</span>
        </h6>
        <div className="flex wrap-dropdown">
          <div className="global-dropdown-block flex-center">
            <label>Task Language</label>
            <div className="global-dropdown-select">
              <Select
                classNamePrefix="cw"
                className="global-dropdown-select"
                value={prop.taskLangs.filter(function (option) {
                  return option.value === selectedLanguages;
                })}
                aria-label="Task Language"
                options={prop.taskLangs}
                onChange={(e) => handleLanguageChange(e)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="form-group">
        <h6 className="subhead-taskform">
          Task Dates <span>(Optional)</span>
        </h6>
        <div className="flex wrap-dropdown flex-basline">
          <div className="global-dropdown-block flex-center firstCal">
            <label htmlFor='calFirstFocus'>Start Date</label>
            <div className="global-dropdown-select">
              <button
                onClick={(e) => {
                  showCalendarStartDate(e);
                }}
                onKeyDown={(e) => handleEscFocus(e)}
                id='calFirstFocus'
                ref={refToggle}
                tabIndex={0}
                type="button"
                className="drop-down-btn gb-dropBtn"
                aria-expanded={toggle ? 'true':'false'}
                aria-label={toggle ? 'choose date dialog': startDate !== ""? `start date ${dateUtil.format(startDate,null,null)} selected` :""}
              >
                <span>{startDate !== ""? dateUtil.format(startDate,null,null) :""}</span>
                <span className="font-zero">{startDate !== ""? dateUtil.format(startDate,null,null) :"Start Date"}</span>
                <svg
                  aria-hidden="true"
                  className="calender-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
                    fill="#3564EB"
                  />
                </svg>
              </button>
            </div>
            {toggle ? (
              <div
                ref={refCalendar}
                onKeyDown={(e) => {
                  closeCalendar(e);
                }}
              >
                <DatePickerCalendar
                 defaultValue={ new Date()}
                 className="dashCalendar"
                 minDate={new Date()}
                 selectDate={selectStartDate}
                />
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="global-dropdown-block flex-center caltopset">
            <label htmlFor='calSecondFocus'>Due Date</label>
            <div className="global-dropdown-select">
              <button
                onClick={(e) => {
                  showCalendarDueDate(e);
                }}
                onFocus={()=>toggleCal(false)}
                onKeyDown={(e) => handleEscFocus2(e)}
                ref={refToggle1}
                id='calSecondFocus'
                tabIndex={0}
                type="button"
                className="drop-down-btn gb-dropBtn"
                aria-expanded={toggle1 ? 'true':'false'}
                aria-label={toggle1 ? 'choose date dialog': dueDate !== ""? `due date ${dateUtil.format(dueDate,null,null)} selected` :""}
               >
                <span>{dueDate !== ""? dateUtil.format(dueDate,null,null) :""}</span>
                <span className="font-zero">{dueDate !== ""? dateUtil.format(dueDate,null,null):"Due Date"}</span>
                <svg
                  aria-hidden="true"
                  className="calender-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
                    fill="#3564EB"
                  />
                </svg>
              </button>
            </div>
            {toggle1 ? (
              <div
                ref={refCalendar1}
                onKeyDown={(e) => {
                  closeCalendar2(e);
                }}
              >
                <DatePickerCalendar
                value={new Date()}
                className="dashCalendar1"
                minDate={new Date(addDaysToDate(startDate, 1, ""))}
                 selectDate={selectDueDate}
                />
              </div>
            ) : (
              ""
            )}
            <div className="form-check-outer">
            <div className="form-check small-checkbox">
              <input
                type="checkbox"
                id="remind_assignee"
                disabled={dueDate === "" ? true : false}
                onChange={setReminder}
              />
              <label htmlFor="remind_assignee">Remind Assignee</label>
            </div>
            <div className="form-number flex-center">
              <input
                type="text"
                id="emailReminderDay"
                name="emailReminderDay"
                maxLength={2}
                className="form-control-sm"
                disabled={!allowReminder}
                onChange={handleReminderDay}
                value={reminderDay}
              />
              <label htmlFor="emailReminderDay">Days before due date</label>
            </div>
            {reminderDateStatus ? <span className="textDanger">Reminder date must be in the future</span> : ""} 
          </div>
          </div>
        </div>
        <div className="flex justify-end btn-gap">
          <button className="btn btn-bold" onClick={updateTask} disabled={taskName === "" || selectedAssignedUser === "" || reminderDateStatus}>
            Save
          </button>
          <button type="button" className="btn btn-bold" onClick={resetfelds}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
